import React from "react";
import { Col, Row } from "react-bootstrap";
import { NFTextInput } from "../../../Shared/NewForms/NFTextInput";
import { NFDateInput } from "../../../Shared/NewForms/NFDateInput";
import { NFLookupAccount } from "../../../Shared/NewForms/NFLookupAccount";

const ExpenseItemDetailMain = () => {
  return (
    <>
      <Row>
        <Col sm={6}>
          <NFTextInput title={"Name"} fieldName={"name"} />
        </Col>
        <Col sm={6}>
          <NFTextInput title={"Unique code"} fieldName={"uniqueCode"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFDateInput fieldName={"createdDate"} title={"Created Date"} />
        </Col>
        <Col sm={6}>
          <NFLookupAccount fieldName={"accountId"} title={"Account"} />
        </Col>
      </Row>
      <Row>
        <Col sm={6}>
          <NFTextInput fieldName={"analyticsTypeOfIncomeId"} title={"Analytics Type of IncomeId"} />
        </Col>
      </Row>
    </>
  );
};

export default ExpenseItemDetailMain;
